var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--colors-brand)",
    d: "m15.562 12.997-4.941 5.074a.867.867 0 0 1-1.144.087l-.09-.079-4.95-5.082a.958.958 0 0 1 0-1.333.906.906 0 0 1 1.283-.017l3.354 3.444V2.595a.927.927 0 1 1 1.853 0l.001 12.496 3.336-3.427a.905.905 0 0 1 1.282-.017l.016.017a.954.954 0 0 1 0 1.333z",
    fillRule: "evenodd"
  })));
};
export default SvgIconArrowDown;